import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Grid from '@mui/material/Grid';
import HelpIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: '.3em',
		'& button': {
			float: 'right',
			marginLeft: '.5em',
		},
	},
}));

// Flip to true when Airchain has documentation of its own and
// utils/help.js maps topics to it.
const HELP_DOCS_AVAILABLE = false;

const Component = function (props) {
	const classes = useStyles();

	return (
		<Grid container spacing={props.spacing} padding={props.padding}>
			<Grid item xs={12} className={classes.root}>
				{typeof props.onAbort === 'function' && (
					<IconButton color="inherit" size="small" onClick={props.onAbort}>
						<CloseIcon />
					</IconButton>
				)}
				{typeof props.onEdit === 'function' && (
					<IconButton color="inherit" size="small" onClick={props.onEdit} disabled={props.editDisabled} title={props.editTitle}>
						<EditIcon />
					</IconButton>
				)}
				{typeof props.onAdd === 'function' && (
					<IconButton color="inherit" size="small" onClick={props.onAdd}>
						<AddIcon />
					</IconButton>
				)}
				{/* Hidden until Airchain has documentation of its own: every topic
				in utils/help.js pointed at another company's manual, and the two
				icons on the home screen had no topic mapped at all, so they
				opened that company's docs homepage and logged a console warning.
				A button that hands the customer to a different vendor is worse
				than no button. The prop and this block stay so wiring real docs
				is a one-line change. See CUSTOMER-FACING-AUDIT-PROGRESS.md. */}
				{HELP_DOCS_AVAILABLE && typeof props.onHelp === 'function' && (
					<IconButton color="inherit" size="small" onClick={props.onHelp}>
						<HelpIcon />
					</IconButton>
				)}
				<Typography variant={props.variant}>{props.title}</Typography>
			</Grid>
		</Grid>
	);
};

export default Component;

Component.defaultProps = {
	spacing: 0,
	padding: null,
	title: '',
	variant: 'pagetitle',
	onAbort: null,
	onHelp: null,
	onEdit: null,
	onAdd: null,
	// A card whose configuration affordance can be temporarily unavailable
	// (Captions.js while captions are starting) needs to say so on the
	// button itself rather than drop it out of the header.
	editDisabled: false,
	editTitle: null,
};
